export const getParsedHashtagText = (text: string | undefined) => {
  return text?.replace('#', '')?.replace('  ', ' ')?.trim();
};

export const firstElementStartWithHashtag = (
  items: Array<string | undefined>,
) => {
  return items?.[0]?.startsWith('#');
};
